import React, { useEffect } from 'react';
import { Outlet, Link } from "react-router-dom";
import { Layout, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../../components/LanguageSelector';
import tbfLogo from '../../assets/images/tbf-logo.png';
import './style.scss';

const { Header, Content } = Layout;
const { Text } = Typography;

export const TbfLayout = () => {
  const { t, i18n } = useTranslation();

  // Apply RTL direction for Arabic, LTR otherwise.
  useEffect(() => {
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
  }, [i18n.language]);

  return (
    <Layout className='tbf-layout-root'>
      <Header className='tbf-header'>
        <div className='tbf-header-left'>
          <Link to='/oic-tbf' className='tbf-brand'>
            <img src={tbfLogo} alt='OIC-TBF' className='tbf-logo' />
            <Text className='tbf-brand-text'>{t('tbf.title')}</Text>
          </Link>
        </div>
        <div className='tbf-header-right'>
          <LanguageSelector />
        </div>
      </Header>
      <Layout className='tbf-page-layout'>
        <Content className='tbf-content'>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
